// let tinymcekey = process.env.VUE_APP_TINYMCE_KEY;
// export default tinymcekey


const keys = [
    //process.env.VUE_APP_TINYMCE_KEY_1,
    process.env.VUE_APP_TINYMCE_KEY_2,
    process.env.VUE_APP_TINYMCE_KEY_3,
    //process.env.VUE_APP_TINYMCE_KEY_4 // safe even if not defined
  ].filter(Boolean); // removes undefined if you only have 3 keys
  
  // Randomly pick one
  const tinymcekey = keys[Math.floor(Math.random() * keys.length)];
  export default tinymcekey;